module.exports = __webpack_public_path__ + "static/logo-2cf0b19fe6afb054c13340f72259be47.png";